import styled from 'styled-components';

import { StarOutlineIc } from '@dsch/dd-icons';

import { StickyFooter } from '../../../../components/ToolkitV2/StickyFooter/StickyFooter';
import { Button } from '../../../../components/Toolkit/Button/Button';
import { Tooltip } from '../../../../components/ToolkitV2/Tooltip/Tooltip';

const StyledStickyFooter = styled(StickyFooter)`
  display: flex;
  justify-content: center;

  padding: ${({ theme }) =>
    `${theme.spacing.S8} ${theme.spacing.S8} ${theme.spacing.M24}`};
`;

const StickySavedSearchButton = styled(Button)`
  width: auto;
  padding: 0 ${({ theme }) => theme.spacing.M16};
  pointer-events: auto;
  box-shadow: 0 2px 8px rgba(88, 97, 118, 0.12);
`;

const Container = styled.div<{
  active?: boolean;
}>`
  display: flex;
  justify-content: center;

  visibility: ${({ active }) => (active ? 'visible' : 'hidden')};
  transform: ${({ active }) => (active ? 'translateY(0)' : 'translateY(72px)')};
  transition: transform 0.25s ease-in-out,
    visibility 0s linear ${({ active }) => (active ? '0s' : '0.25s')};
`;

const SavedSearchTooltip = styled(Tooltip)`
  display: flex;
  justify-content: center;
  width: 260px;
`;

const SaveIcon = styled(StarOutlineIc)`
  color: ${({ theme }) => theme.donedeal.colors.WHITE};
`;

export {
  StyledStickyFooter,
  StickySavedSearchButton,
  Container,
  SavedSearchTooltip,
  SaveIcon,
};
